import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import type { PanelState } from "./TourCard";
import PhosphorIcon, {
  type PhosphorIconName,
} from "@/shared/components/common/PhosphorIcon";

interface TourCardToggleProps {
  handleToggleState: (panel: PanelState) => () => void;
  panel: PanelState;
  label: string;
  icon: PhosphorIconName;
  isOpen: boolean;
}

export default function TourCardToggle({
  handleToggleState,
  panel,
  label,
  icon,
  isOpen,
}: TourCardToggleProps) {
  return (
    <Flex
      onClick={handleToggleState(panel)}
      gap={"2"}
      alignItems={"center"}
      className="rounded-full p-1 px-2 cursor-pointer group"
    >
      <PhosphorIcon
        name={icon}
        weight={isOpen ? "fill" : "regular"}
        className="md:w-6 md:h-6 cursor-pointer text-foreground group-hover:text-primary transition duration-75 ease-in-out"
      />
      <Typography
        variant="caption"
        fontWeight="normal"
        className="text-black dark:text-foreground md:text-sm group-hover:text-primary transition duration-75 ease-in-out"
      >
        {label}
      </Typography>
    </Flex>
  );
}
